export default "__VITE_PUBLIC_ASSET__6fb5477d__"